export const API_CONFIG = {
  baseURL: process.env.REACT_APP_ODOO_URL || 'http://localhost:8069',
  database: process.env.REACT_APP_ODOO_DB || 'odoo_demo',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const ENDPOINTS = {
  // Authentication
  login: '/web/session/authenticate',
  logout: '/web/session/destroy',
  
  // Bookings
  bookings: '/api/bookings',
  bookingDetail: (id: number) => `/api/bookings/${id}`,
  
  // Documents
  documents: '/api/documents',
  documentUpload: '/documents/upload',
  documentSign: '/document/sign',
  
  // JSON-RPC endpoints
  jsonrpc: '/api/jsonrpc',
};